import { ScrollReveal } from "./ScrollReveal";
import founderAvatar from "@/assets/founder-avatar.png";

export const FounderSection = () => {
  return (
    <section className="py-12 md:py-20 relative" style={{ background: "#FAFAFA" }}>
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <ScrollReveal>
          <div className="max-w-[640px] mx-auto text-center">
            <img
              src={founderAvatar}
              alt="Isaac, Founder of AI StoryCraft Studio"
              className="w-20 h-20 rounded-full mx-auto mb-6 object-cover"
            />

            <h2 className="font-display font-bold mb-6" style={{ color: "#111827", fontSize: "clamp(24px, 3.5vw, 40px)" }}>
              Built by Isaac
            </h2>

            <p className="leading-relaxed mb-6 italic" style={{ color: "#4B5563", fontSize: "18px" }}>
              "I built AI StoryCraft Studio because I watched talented creators with small audiences
              struggle to monetise — while less talented creators with systems made thousands. This
              platform is the system I wish existed when I started."
            </p>

            <p className="text-sm font-semibold mb-6" style={{ color: "#111827" }}>
              — Isaac, Founder of AI StoryCraft Studio
            </p>

            <div className="flex items-center justify-center gap-4" style={{ fontSize: "14px" }}>
              <a href="https://youtube.com/@issacai" target="_blank" rel="noopener noreferrer" className="link-animated" style={{ color: "#6B7280" }}>YouTube</a>
              <a href="https://tiktok.com/@issacai" target="_blank" rel="noopener noreferrer" className="link-animated" style={{ color: "#6B7280" }}>TikTok</a>
              <a href="https://instagram.com/issacai" target="_blank" rel="noopener noreferrer" className="link-animated" style={{ color: "#6B7280" }}>Instagram</a>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};
